
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const preparations = state => state.preparations;
const getsingle = state => param =>state.preparations.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  preparations,
  getsingle
};